import * as types from './constants';

const initialState = {
    globalData: {},
    regionalData: {},
    computedAt: null,
    isGettingAggregateData: false,
    getAggregateDataError: {}
};

function pricesReducer(state = initialState, action) {
    switch(action.type) {
        case types.GET_AGGREGATE_DATA_START:
            return Object.assign({}, state, {
                isGettingAggregateData: true,
                getAggregateDataError: {}
            });
        case types.GET_AGGREGATE_DATA_SUCCESS:
            return Object.assign({}, state, {
                isGettingAggregateData: false,
                ...action.data
            });
        case types.GET_AGGREGATE_DATA_FAILURE:
            return Object.assign({}, state, {
                isGettingAggregateData: false,
                getAggregateDataError: action.error
            });
        default:
            return state;
    }
}

export default pricesReducer;



// WEBPACK FOOTER //
// ./src/containers/AggregateData/store/reducers.js